import { connect } from 'react-redux';

import CustomerActions from 'store/customer/actions';
import { actionGetProvinceList } from 'store/address/actions';

import Customers from './Customers';

const mapStateToProps = (state) => ({
  customers: state.customer.customers,
  totalCustomers: state.customer.totalCustomers,
  customersLoading: state.customer.customersLoading,
  provinces: state.Address.provinces,
  exportCustomerLoading: state.customer.exportCustomerLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getCustomers: (payload) => dispatch(CustomerActions.getCustomers(payload)),
  actionGetProvinceList: (payload) => dispatch(actionGetProvinceList(payload)),
  exportCustomerFile: (payload) => dispatch(CustomerActions.exportCustomerFile(payload)),
  blockCustomer: (payload) => dispatch(CustomerActions.blockCustomer(payload)),
  unblockCustomer: (payload) => dispatch(CustomerActions.unblockCustomer(payload)),
  updateCustomerLevel: (payload) => dispatch(CustomerActions.updateCustomerLevel(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Customers);
